import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
} from "src/app/shared/service";

@Component({
    templateUrl: './dtg.manage.main.component.html'
    ,styleUrls: ["./dtg.manage.main.component.scss"]
    ,providers: []
})
export class DtgManageMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;

    constructor(
        private fvmsCommonService:FvmsCommonService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
            });
     }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }
}